import AppHeader from 'components/AppHeader'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppHeader
  },
  data () {
    return {
      callbackFlag: false
    }
  },
  created () {
    this.search()
  },
  computed: {
    ...mapGetters([
      'proposeTasks',
      'proposeTaskListNextPage',
      'proposeTaskListCurrentPage'
    ])
  },
  methods: {
    search: function (readMore) {
      let url = null
      let data = {}
      if (readMore === true) {
        // さらに20件呼ぶ
        data['page[number]'] = this.proposeTaskListNextPage
      } else if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込する
        data['current_page'] = this.proposeTaskListCurrentPage
      }
      const callback = () => {
        this.callbackFlag = true
      }
      this.$store.dispatch('PROPOSE_TASK_LIST', {data: data, url: url, callback: callback})
    },
    goCreateTitle: function () {
      this.$router.push({path: '/propose_task/new'})
    },
    goEditTitle: function (id) {
      this.$router.push({path: `/propose_task/${id}/edit`})
    },
    deleteTitle: function (id) {
      const callback = () => {
        this.search('keepload')
        this.$forceUpdate()
      }
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('PROPOSE_TASK_DELETE', {id: id, callback: callback})
      }
    },
    formatDate: function (date) {
      const reg = /(\d{4})-(\d{2})-(\d{2})/
      return date.replace(reg, '$1年$2月$3日')
    },
    returnStatusClass: function (status) {
      let result = []
      switch (status) {
        case 'unpublish':
          result.push('color-blue')
          break
        case 'publish':
          result.push('color-orange')
          break
        case 'done':
          result.push('color-gray')
          break
      }
      return result
    },
    returnIsDisabled: function (status) {
      return ['publish', 'done'].includes(status)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-task-list.js